import { render, staticRenderFns } from "./CreateMerchantUserModal.vue?vue&type=template&id=72ba6732&scoped=true&"
import script from "./CreateMerchantUserModal.vue?vue&type=script&lang=js&"
export * from "./CreateMerchantUserModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateMerchantUserModal.vue?vue&type=style&index=0&id=72ba6732&scoped=true&lang=css&"
import style1 from "./CreateMerchantUserModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ba6732",
  null
  
)

export default component.exports